import makeRequest from './client';

const usageBaseURL = `/api/usage`;

/** Filters for the combined usage report (single endpoint). */
export type UsageReportFilters = {
  organization?: string;
  from?: string;
  to?: string;
};

/**
 * Single combined usage report: RUM + user-stats merged on the backend.
 * GET /api/usage/report?organization=...&from=...&to=...
 */
export const getUsageReport = (filters?: UsageReportFilters) => {
  const queryParams = new URLSearchParams();
  if (filters?.organization) queryParams.append('organization', filters.organization);
  if (filters?.from) queryParams.append('from', filters.from);
  if (filters?.to) queryParams.append('to', filters.to);

  const finalURL = `${usageBaseURL}/report?${queryParams.toString()}`;
  return makeRequest(finalURL, 'GET');
};
